import './PlanAreaPath.css';

import React from 'react';
import { Box } from '@mui/material';
import FieldText from '../../b2b-common/FieldText';
import { generateClassName, truncateTextByCharacters } from '../../b2b-common/helpers';

const PlanLink = ({ plan, charsLimit = 25, linkable = true }) => {
    return (
        <Box className='PlanLink-container'>
            <FieldText label='Plan:'
                text={truncateTextByCharacters(plan.planName, charsLimit)} className={'PlanLink-field theme-fieldtex-horizontal-01'}
                //textLink={`/plans/plans-explorer?selectedPlanId=${encodeURIComponent(plan.planId)}`}
                textLink={linkable ? `/plans/plans-explorer/${plan.planUUID}` : null}
            />
        </Box>
    );
};

const AreaLink = ({ area, charsLimit = 25, linkable = true }) => {
    return (
        <Box className='AreaLink-container'>
            <FieldText label='Area:'
                text={truncateTextByCharacters(area.areaName, charsLimit)} className={'AreaLink-field theme-fieldtex-horizontal-01'}
                textLink={linkable ? `/plans/plans-explorer/${area.plan.planUUID}?selectedAreaId=${encodeURIComponent(area.areaId)}` : null}
            />
        </Box>
    );
}

const PlanAreaPath = ({ plan, area, linkable = true, className = null }) => {
    return (
        <Box className={generateClassName('PlanAreaPath-container','', className)}>
            <PlanLink plan={plan} linkable={linkable} />
            <Box className='PlanAreaPath-separator'>{'|'}</Box>
            <AreaLink area={area} linkable={linkable} />
        </Box>
    );
};

export default PlanAreaPath;